"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummitLogistics = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
const constants_1 = require("../../constants");
class SummitLogistics extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SUMMIT_LOGISTICS,
            tags: [Tags_1.Tags.BUILDING, Tags_1.Tags.SPACE],
            cost: 10,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.SCIENTISTS)),
            metadata: {
                cardNumber: 'P85',
                description: 'Requires that Scientists are ruling or that you have 2 delegates there. Gain 1 M€ per planet tag and colony you have. Draw 2 cards.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(1).slash().jovian(true).played.earth(1, true).played.venus(1, Size_1.Size.MEDIUM, true).played.nbsp(Size_1.Size.SMALL).plus(Size_1.Size.SMALL).colonies(1, Size_1.Size.SMALL);
                    b.br.br;
                    b.cards(2);
                }),
            },
        });
    }
    canPlay(player) {
        const turmoil = player.game.turmoil;
        if (turmoil !== undefined) {
            if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.SCIENTISTS)) {
                return turmoil.canPlay(player, PartyName_1.PartyName.SCIENTISTS);
            }
            return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
        }
        return false;
    }
    play(player) {
        const planetTagsCount = player.getMultipleTagCount([Tags_1.Tags.JOVIAN, Tags_1.Tags.EARTH, Tags_1.Tags.VENUS]);
        const coloniesCount = player.getColoniesCount();
        player.addResource(Resources_1.Resources.MEGACREDITS, planetTagsCount + coloniesCount, { log: true });
        player.drawCard(2);
        return undefined;
    }
}
exports.SummitLogistics = SummitLogistics;
//# sourceMappingURL=SummitLogistics.js.map